import { Address } from '@app/domain/model/Address';

interface AddressParams {
    street?: string;
    houseNumber?: string;
    apartmentNumber?: string;
    city?: string;
    municipality?: string;
    postalCode?: string;
    country?: string;
}

export function formatAddress(
    address: AddressParams | Address | null | undefined,
    options: {
        includeMunicipality?: boolean;
        includePostalCode?: boolean;
        includeCountry?: boolean;
        separator?: string;
    } = {},
): string {
    if (!address) {
        return '';
    }

    const { includeMunicipality = true, includePostalCode = true, includeCountry = false, separator = ', ' } = options;

    const addressParts: string[] = [];

    if (address.street && address.houseNumber) {
        const streetPart = address.apartmentNumber
            ? `${address.street} ${address.houseNumber}-${address.apartmentNumber}`
            : `${address.street} ${address.houseNumber}`;
        addressParts.push(streetPart);
    } else if (address.street) {
        addressParts.push(address.street);
    }

    if (address.city) {
        addressParts.push(address.city);
    }

    if (includeMunicipality && address.municipality) {
        addressParts.push(address.municipality);
    }

    if (includePostalCode && address.postalCode) {
        addressParts.push(address.postalCode);
    }

    if (includeCountry && address.country) {
        addressParts.push(address.country);
    }

    return addressParts.filter(Boolean).join(separator);
}
